import React, { useState } from 'react'
import './user-profile.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const ResetPassword = ({ setInfoFun, info, handleSubmit, isSubmitting }) => {
    const [passError, setPassError] = useState({
        notMatch: false,
        length: false,
    })
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const onSubmit = (event) => {
        event?.preventDefault()
        const pwd = info?.password ?? ''
        const conf = info?.conf_password ?? ''
        if (pwd !== conf) {
            setPassError({ notMatch: true, length: false })
            return
        }
        if (pwd.length < 6) {
            setPassError({ notMatch: false, length: true })
            return
        }
        setPassError({ notMatch: false, length: false })
        handleSubmit()
    }

    const clearError = () => {
        setPassError({ notMatch: false, length: false })
    }

    return (
        <div className="basic-info profile-panel profile-reset-panel-wrap">

            <form onSubmit={onSubmit}>
                <div className="profile-panel__toolbar">
                    <div>
                        <h2 className="profile-panel__title">Reset password</h2>
                        <p className="profile-panel__subtitle">Choose a new password at least 6 characters long.</p>
                    </div>
                    <button type="submit" className="btn save-button">
                        Update password
                        {isSubmitting && (
                            <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true" />
                        )}
                    </button>
                </div>

                <div className="profile-fields">
                    <div className="profile-field mb-2">
                        <label className="profile-field__label form-label" htmlFor="reset-pass-new">New password</label>
                        <div className="profile-password-wrap">
                            <input
                                id="reset-pass-new"
                                autoComplete="new-password"
                                type={showNew ? 'text' : 'password'}
                                className="form-control"
                                onChange={(e) => {
                                    clearError()
                                    setInfoFun('password', e.target.value)
                                }}
                                placeholder="Enter new password"
                            />
                            <button
                                type="button"
                                className="profile-password-toggle"
                                onClick={() => setShowNew((s) => !s)}
                                tabIndex={-1}
                                aria-label={showNew ? 'Hide password' : 'Show password'}
                            >
                                <FontAwesomeIcon icon={showNew ? faEyeSlash : faEye} className="text-secondary" />
                            </button>
                        </div>
                    </div>

                    <div className="profile-field mb-2">
                        <label className="profile-field__label form-label" htmlFor="reset-pass-confirm">Confirm password</label>
                        <div className="profile-password-wrap">
                            <input
                                id="reset-pass-confirm"
                                autoComplete="new-password"
                                type={showConfirm ? 'text' : 'password'}
                                className="form-control"
                                onChange={(e) => {
                                    clearError()
                                    setInfoFun('conf_password', e.target.value)
                                }}
                                placeholder="Re-enter new password"
                            />
                            <button
                                type="button"
                                className="profile-password-toggle"
                                onClick={() => setShowConfirm((s) => !s)}
                                tabIndex={-1}
                                aria-label={showConfirm ? 'Hide password' : 'Show password'}
                            >
                                <FontAwesomeIcon icon={showConfirm ? faEyeSlash : faEye} className="text-secondary" />
                            </button>
                        </div>
                    </div>

                    {(passError.notMatch || passError.length) && (
                        <div className="profile-reset-alert" role="alert">
                            {passError.notMatch && <span>Passwords do not match.</span>}
                            {passError.length && <span>Password must be at least 6 characters.</span>}
                        </div>
                    )}
                </div>
            </form>
        </div>
    )
}

export default ResetPassword
